export const isHlgEnvironment = () => process.env.NODE_ENV === 'development' || process.env.VUE_APP_ENVIRONMENT === 'hlg'
